/** Maps ISO 3166-1 alpha-3 country codes (from the API) to flagcdn.com alpha-2 codes */
const ALPHA3_TO_FLAGCDN: Record<string, string> = {
  AFG: 'af', ALB: 'al', ALG: 'dz', AND: 'ad', ANG: 'ao', ARG: 'ar', ARM: 'am',
  AUS: 'au', AUT: 'at', AZE: 'az', BEL: 'be', BEN: 'bj', BIH: 'ba', BLR: 'by',
  BOL: 'bo', BRA: 'br', BUL: 'bg', CMR: 'cm', CAN: 'ca', CHE: 'ch', CHL: 'cl',
  CHN: 'cn', COL: 'co', CRI: 'cr', CRO: 'hr', HRV: 'hr', CZE: 'cz', DEN: 'dk',
  DNK: 'dk', DEU: 'de', ECU: 'ec', EGY: 'eg', ENG: 'gb-eng', ESP: 'es',
  EST: 'ee', ETH: 'et', FIN: 'fi', FRA: 'fr', GAB: 'ga', GBR: 'gb', GEO: 'ge',
  GER: 'de', GHA: 'gh', GRC: 'gr', GRE: 'gr', GTM: 'gt', HND: 'hn', HUN: 'hu',
  IDN: 'id', IND: 'in', IRL: 'ie', IRN: 'ir', IRQ: 'iq', ISL: 'is', ISR: 'il',
  ITA: 'it', JAM: 'jm', JPN: 'jp', KAZ: 'kz', KEN: 'ke', KOR: 'kr', KSA: 'sa',
  SAU: 'sa', LTU: 'lt', LUX: 'lu', LVA: 'lv', MAR: 'ma', MDA: 'md', MEX: 'mx',
  MKD: 'mk', MLT: 'mt', MNE: 'me', MOL: 'md', MOR: 'ma', MYS: 'my', NED: 'nl',
  NGA: 'ng', NLD: 'nl', NOR: 'no', NZL: 'nz', PAN: 'pa', PER: 'pe', POL: 'pl',
  PRT: 'pt', PRY: 'py', QAT: 'qa', ROU: 'ro', RUS: 'ru', SCO: 'gb-sct',
  SEN: 'sn', SRB: 'rs', SVK: 'sk', SVN: 'si', SWE: 'se', SUI: 'ch', THA: 'th',
  TUN: 'tn', TUR: 'tr', UKR: 'ua', URY: 'uy', USA: 'us', UZB: 'uz', VEN: 've',
  WAL: 'gb-wls', ZAF: 'za',
};

/**
 * Returns a flagcdn.com image URL for the given ISO 3166-1 alpha-3 country code.
 * Returns null if the code is unknown or falsy.
 */
export function getCountryFlagUrl(countryCode: string | null | undefined): string | null {
  if (!countryCode) return null;
  const alpha2 = ALPHA3_TO_FLAGCDN[countryCode.toUpperCase()];
  if (!alpha2) return null;
  return `https://flagcdn.com/w20/${alpha2}.png`;
}
